import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import {
  StyledText,
  DynamicButton,
  MainHolder,
  Children,
  Body,
} from "../../../../components/common/basic";

import { logEvent } from "firebase/analytics";
import analytics from "../../../../context/analytics";
import {
  AlertModal,
  BackButton,
  FullScreenSelect,
  QuantityControl,
} from "../../../../components/common";
import RewardItemCard from "../../trivia/components/RewardItemCard";
import useTriviaPickup from "../../trivia/hooks/useTriviaPickup";
import TriviaRedemptionStatus from "../../trivia/components/TriviaRedemptionStatus";
import { useTrivia, useSpinTheWheel } from "../../../../hooks";
import { useSpinTheWheelHome } from "../hooks";

const VoucherRedemption = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "TriviaPickup",
        firebase_screen_class: "TriviaPickup",
      })
    );
  }, []);

  const {
    background,
    history,
    regionFmt,
    showAlert,
    setShowAlert,
    region,
    setRegion,
    officeLocation,
    setOfficeLocation,
    officeLocations,
    updatedUserPoints,
  } = useTriviaPickup();

  const { submitOrderLocation } = useSpinTheWheel();
  const { getItemFromStock, itemWon, whiteListedLocations, isOnGround } = useSpinTheWheelHome();

  const { imageUrl, name } = getItemFromStock(itemWon?.code);

  useEffect(() => {
    if (itemWon?.code && whiteListedLocations?.length && isOnGround) {
      submitOrderLocation({
        itemCode: itemWon?.code,
        officeLocation: whiteListedLocations[0],
        region: "Greater Accra Region", // TODO: Get dynamically
      })
      setShowAlert(true);
    }
  }, [itemWon?.code, whiteListedLocations, isOnGround]);

  const handleSubmit = () => {
    submitOrderLocation({
      itemCode: itemWon?.code,
      officeLocation,
      region,
    })
    setShowAlert(true);
  };


  return (
    <>
      <MainHolder>
        <BackButton
          onClick={() => {
            history.goBack();
          }}
        />
        <Children>
          <Header>
            <div style={{ textAlign: "center" }}>
              <StyledText
                size={24}
                style={{ fontFamily: "MTNMedium" }}
                margin="0"
              >
                {"Order"}
              </StyledText>
            </div>
          </Header>
          <Body>
            {
              showAlert && (
                <AlertModal
                  background={background}
                  success={true}
                  onClick={() => {
                    setShowAlert(false);
                  }}
                >
                  <TriviaRedemptionStatus
                    title="Order completed!"
                    background={background}
                    history={history}
                    onActionClick={() => history.push("/spin_the_wheel/orders")}
                  />
                </AlertModal>
              )
            }
            <div style={{ boxSizing: "border-box", padding: "0 15px" }}>
              <RewardItemCard
                color={background}
                image={imageUrl}
                points={"Prize"}
                name={name}
              />
              <hr
                style={{
                  margin: "15px 0",
                  borderTop: "none",
                  borderBottom: "1px solid #ddd",
                }}
              />

              <div style={{ marginBottom: "150px" }}>
                <StyledText size={18} style={{ fontFamily: "MTNRegular" }}>
                  Pickup from MTN Office{" "}
                </StyledText>
                <FullScreenSelect
                  placeholder="Region"
                  data={regionFmt}
                  selected={region}
                  setValue={setRegion}
                  activeColor={background}
                />
                <FullScreenSelect
                  placeholder="MTN Office"
                  data={officeLocations}
                  selected={officeLocation}
                  setValue={setOfficeLocation}
                  activeColor={background}
                />
              </div>

              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  background: "#fff",
                  borderTop: "1px solid #ddd",
                }}
              >
                <div style={{ padding: "10px" }}>
                  {updatedUserPoints < 0 && (
                    <StyledText
                      color="red"
                      style={{ textAlign: "center", margin: 0 }}
                    >
                      You do not have enough points to redeem
                    </StyledText>
                  )}
                </div>
                <div style={{ padding: "10px 30px" }}>
                  <DynamicButton
                    onClick={handleSubmit}
                    label={"Submit"}
                    disabled={!region || !officeLocation}
                    color={background}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default VoucherRedemption;
